export const contactUs = '/user/contact-us';
export const changeCurrency = '/user/update-default-currency';
export const getNotifications = '/notifications';
export const getPayeeDetails = '/payee/payee-details';
export const joinTeamRequest = "/teams/joinTeamRequest"
export const getGoogleReviews = "/transactionfeedback/getGoogleReviews"
export const sendGoogleId = "/transactionfeedback/userGoogleData"
export const disconnetGoogle = "/user/unlinkGoogleAccount"
export const getMyDetails = "/user/get-my-details";
